import { render, staticRenderFns } from "./counseling-center.vue?vue&type=template&id=16b36e75&scoped=true&"
import script from "./counseling-center.vue?vue&type=script&lang=js&"
export * from "./counseling-center.vue?vue&type=script&lang=js&"
import style0 from "./counseling-center.vue?vue&type=style&index=0&id=16b36e75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b36e75",
  null
  
)

export default component.exports